/**
 * @owner @Appboy/messaging-experience
 */
import type { SelectableMessageType } from "@lib/campaignMessageTypeConstants";

import { isMessagePrioritizationEligibleChannel } from "./isMessagePrioritizationEligibleChannel";

/**
 * Whether the current channel selection can use Message Prioritization.
 * An empty selection is treated as eligible so Delivery settings stay usable
 * until the user picks a channel. Two or more channels are never eligible.
 *
 * @param types - Currently selected message types on the step.
 * @returns True when there is at most one channel and every selected channel is allowlisted.
 */
export const isPrioritizableChannelSelection = (types: readonly SelectableMessageType[]): boolean => {
  if (types.length > 1) {
    return false;
  }
  return types.every((type) => isMessagePrioritizationEligibleChannel(type));
};
